/**
 * Suite Customizer — data-driven, works for any suite.
 * All suite identity, pricing, and asset config comes from
 * window.SUITE_CONFIG, emitted by the suite-customizer section's Liquid.
 */

// ── Suite config (injected by Liquid before this script runs) ─────────────────
const CFG     = window.SUITE_CONFIG || {};
const SUITE_ID = CFG.suiteId || 'lyla';

// Parse compact pricing text: one "qty:single:duo:trio" per line
function parsePricingText(text) {
  const base = {};
  if (!text) return base;
  text.trim().split('\n').forEach(line => {
    const parts = line.trim().split(':').map(Number);
    const [qty, single, duo, trio] = parts;
    if (qty) base[qty] = { single, duo, trio };
  });
  return base;
}

const PRICING = {
  base:   parsePricingText(CFG.pricingText || ''),
  addons: CFG.addons || {
    envelopeLiner: { preselected: 1.50, customvenue: 4.00 },
    guestAddressing:  1.25,
    returnAddressing: 45,
    rehearsalInsert:  1.50,
  },
};

// ── Piece descriptions ────────────────────────────────────────────────────────
const PIECE_HINTS = {
  single: 'Invitation only',
  duo:    'Invitation + detail card',
  trio:   'Invitation + detail card + RSVP card',
};

// ── Font color labels ─────────────────────────────────────────────────────────
const FONT_COLOR_LABELS = {
  noir:          'Noir',
  woodlandgreen: 'Woodland Green',
  dustyblue:     'Dusty Blue',
  navy:          'Navy',
  spice:         'Spice',
};

// ── Envelope color labels ─────────────────────────────────────────────────────
const ENV_COLOR_LABELS = {
  coolblue:  'Cool Blue',
  blush:     'Blush',
  pistachio: 'Pistachio',
  white:     'White',
  warmwhite: 'Warm White',
};

// ── State ─────────────────────────────────────────────────────────────────────
const state = {
  quantity:         null,
  pieces:           'single',
  fontPairing:      CFG.defaultFontPairing || 'romantic',
  fontColor:        'noir',
  envelopeColor:    'coolblue',
  envelopeLiner:    'no',
  linerType:        CFG.suiteId || 'lyla', // defaults to the current suite's own liner
  guestAddressing:  'no',
  returnAddressing: 'no',
  rehearsalInsert:  'no',
  rehearsalQty:     25,
};

// ── Asset URL helpers ─────────────────────────────────────────────────────────

// Builds a CDN URL for a given asset filename
function assetUrl(filename) {
  return (CFG.assetBase || window.LYLA_ASSET_BASE || '') + filename;
}

// Envelope piece — shared across all suites, color-variant, cache-busted
function envelopeSrc(variant) {
  return assetUrl(`semi_custom_general_${variant}_${state.envelopeColor}.png`) + '?v=2';
}

// Suite-specific liner — {suiteId}_liner_{color}.png
// Used when the customer picks a named suite liner (not custom venue illo)
function linerSrc(suiteId) {
  return assetUrl(`${suiteId}_liner_${state.envelopeColor}.png`);
}

// Card piece — font pairing + optional font color
// Cards listed in CFG.fontOnlyCards (e.g. details for Catherine) skip the color suffix
function cardSrc(piece) {
  const fontOnlyCards = Array.isArray(CFG.fontOnlyCards) ? CFG.fontOnlyCards.filter(Boolean) : [];
  if (fontOnlyCards.includes(piece)) {
    return assetUrl(`${SUITE_ID}_${piece}_${state.fontPairing}.png`);
  }
  return assetUrl(`${SUITE_ID}_${piece}_${state.fontPairing}_${state.fontColor}.png`);
}

// Rehearsal — routes through cardSrc() so fontOnlyCards logic applies.
// Suites with rehearsal in fontOnlyCards (e.g. Lyla) get font-pairing only.
// Suites without it (e.g. Callie) get font-pairing + color suffix.
function rehearsalSrc() {
  return cardSrc('rehearsal');
}

// ── Flatlay loader ────────────────────────────────────────────────────────────

// Shows the loading overlay
function showLoader() {
  const loader = document.getElementById('flLoading');
  if (!loader) return;
  loader.classList.remove('fl-loading--hidden');
}

// Hides loader once all visible images have finished loading
function hideLoaderWhenReady() {
  const loader = document.getElementById('flLoading');
  if (!loader) return;
  const imgs = document.querySelectorAll('#suiteFlatlay img');
  const visibleImgs = Array.from(imgs).filter(img =>
    !img.closest('.fl-piece--hidden') && img.src
  );
  let loaded = 0;
  const total = visibleImgs.length;
  if (total === 0) { loader.classList.add('fl-loading--hidden'); return; }
  visibleImgs.forEach(img => {
    if (img.complete) {
      loaded++;
      if (loaded >= total) loader.classList.add('fl-loading--hidden');
    } else {
      img.addEventListener('load',  () => { loaded++; if (loaded >= total) loader.classList.add('fl-loading--hidden'); }, { once: true });
      img.addEventListener('error', () => { loaded++; if (loaded >= total) loader.classList.add('fl-loading--hidden'); }, { once: true });
    }
  });
}

// Sets an img element's src
function setFlatImg(imgId, src) {
  const img = document.getElementById(imgId);
  if (img) img.src = src;
}

// Shows or hides a flatlay piece
function showFlat(elId, visible) {
  const el = document.getElementById(elId);
  if (!el) return;
  if (visible) el.classList.remove('fl-piece--hidden');
  else         el.classList.add('fl-piece--hidden');
}

function renderFlatlay() {
  showLoader();
  const hasLiner  = state.envelopeLiner    === 'yes';
  const hasGuest  = state.guestAddressing  === 'yes';
  const hasReturn = state.returnAddressing === 'yes';

  // Inner envelope — suite-specific liner, shared custom venue liner, or plain envelope
  let innerEnvSrc;
  if (!hasLiner) {
    // No liner — shared plain inside envelope asset
    innerEnvSrc = envelopeSrc('inside_envelope');
  } else if (state.linerType === 'customvenue') {
    // Custom venue illustration — shared asset across all suites
    innerEnvSrc = envelopeSrc('inside_liner_customvenue');
  } else {
    // Named suite liner — {suiteId}_liner_{color}.png
    innerEnvSrc = linerSrc(state.linerType);
  }
  setFlatImg('flInnerEnvImg', innerEnvSrc);

  // Card images — update on any font pairing / color change
  setFlatImg('flInvitationImg', cardSrc('invitation'));
  setFlatImg('flDetailsImg',    cardSrc('details'));
  setFlatImg('flRsvpImg',       cardSrc('rsvp'));
  setFlatImg('flRehearsalImg',  rehearsalSrc());

  // Details card — duo and trio
  showFlat('flDetails', ['duo', 'trio'].includes(state.pieces));

  // RSVP card — trio only
  showFlat('flRsvp', state.pieces === 'trio');

  // Rehearsal card — add-on only
  showFlat('flRehearsal', state.rehearsalInsert === 'yes');

  // Front envelope — variant depends on addressing selections
  let envFrontVariant = 'envelope';
  if (hasGuest && hasReturn) envFrontVariant = 'envelope_guest_return';
  else if (hasGuest)         envFrontVariant = 'envelope_guest';
  else if (hasReturn)        envFrontVariant = 'envelope_return';
  setFlatImg('flEnvFrontImg', envelopeSrc(envFrontVariant));

  hideLoaderWhenReady();
}

// ── Helpers ───────────────────────────────────────────────────────────────────
function fmt(amount) {
  return '$' + amount.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
}

function showGroup(id, show) {
  const el = document.getElementById(id);
  if (!el) return;
  if (show) {
    el.classList.add('conditional-group--visible');
    el.setAttribute('aria-hidden', 'false');
  } else {
    el.classList.remove('conditional-group--visible');
    el.setAttribute('aria-hidden', 'true');
  }
}

// ── Price calculation ─────────────────────────────────────────────────────────
function calcPrice() {
  const qty = state.quantity;
  if (!qty || !PRICING.base[qty]) return null;

  const lines = [];

  // Base suite cost
  const baseCost = PRICING.base[qty][state.pieces];
  lines.push({ label: `Base suite (${state.pieces}, qty ${qty})`, amount: baseCost });

  // Envelope liner — customvenue gets the upgrade rate; all named suite liners use preselected rate
  if (state.envelopeLiner === 'yes') {
    const linerRate  = state.linerType === 'customvenue'
      ? PRICING.addons.envelopeLiner.customvenue
      : PRICING.addons.envelopeLiner.preselected;
    const linerTotal = linerRate * qty;
    const linerLabel = state.linerType === 'customvenue'
      ? 'Custom venue illustration liner'
      : `Envelope liner (${state.linerType.charAt(0).toUpperCase() + state.linerType.slice(1)})`;
    lines.push({ label: linerLabel, amount: linerTotal });
  }

  // Guest addressing
  if (state.guestAddressing === 'yes') {
    const gaTotal = PRICING.addons.guestAddressing * qty;
    lines.push({ label: `Guest addressing (${qty} suites)`, amount: gaTotal });
  }

  // Return addressing
  if (state.returnAddressing === 'yes') {
    lines.push({ label: 'Return addressing', amount: PRICING.addons.returnAddressing });
  }

  // Rehearsal insert
  if (state.rehearsalInsert === 'yes') {
    const rqty    = state.rehearsalQty || qty;
    const riTotal = PRICING.addons.rehearsalInsert * rqty;
    lines.push({ label: `Rehearsal insert (${rqty})`, amount: riTotal });
  }

  const total = lines.reduce((sum, l) => sum + l.amount, 0);
  return { lines, total };
}

// ── Render ────────────────────────────────────────────────────────────────────
function render() {
  const result           = calcPrice();
  const priceEl          = document.getElementById('suitePrice');
  const summaryEl        = document.getElementById('priceSummary');
  const summaryLinesEl   = document.getElementById('priceSummaryLines');
  const summaryTotalEl   = document.getElementById('priceSummaryTotal');
  const inquirySummaryEl      = document.getElementById('inquiryPriceSummary');
  const inquirySummaryLinesEl = document.getElementById('inquiryPriceSummaryLines');
  const inquirySummaryTotalEl = document.getElementById('inquiryPriceSummaryTotal');

  // Always run these regardless of whether a quantity is selected
  renderFlatlay();
  showGroup('linerTypeGroup',      state.envelopeLiner   === 'yes');
  showGroup('customVenueInfo',     state.linerType       === 'customvenue');
  showGroup('guestAddressingInfo', state.guestAddressing === 'yes');
  showGroup('rehearsalQtyGroup',   state.rehearsalInsert === 'yes');

  const hintEl = document.getElementById('piecesHint');
  if (hintEl) hintEl.textContent = PIECE_HINTS[state.pieces] || '';

  if (!result) {
    if (priceEl)   priceEl.textContent = '—';
    if (summaryEl) {
      summaryEl.setAttribute('aria-hidden', 'true');
      summaryEl.classList.remove('price-summary--visible');
    }
    if (inquirySummaryEl) inquirySummaryEl.classList.remove('inquiry-price-summary--visible');
    return;
  }

  if (priceEl) priceEl.textContent = fmt(result.total);

  // Keep hidden inquiry field updated with current selections
  const summaryInput = document.getElementById('inquirySuiteSummary');
  if (summaryInput) {
    summaryInput.value = [
      `Suite: ${CFG.suiteName || SUITE_ID}`,
      `Quantity: ${state.quantity}`,
      `Pieces: ${state.pieces}`,
      `Font Pairing: ${state.fontPairing}`,
      `Font Color: ${state.fontColor}`,
      `Envelope Color: ${state.envelopeColor}`,
      `Envelope Liner: ${state.envelopeLiner}${state.envelopeLiner === 'yes' ? ' (' + (state.linerType === 'customvenue' ? 'Custom Venue' : state.linerType + ' liner') + ')' : ''}`,
      `Guest Addressing: ${state.guestAddressing}`,
      `Return Addressing: ${state.returnAddressing}`,
      `Rehearsal Insert: ${state.rehearsalInsert}${state.rehearsalInsert === 'yes' ? ' (qty: ' + state.rehearsalQty + ')' : ''}`,
      `Estimated Total: ${fmt(result.total)}`,
    ].join(' | ');
  }

  // Shared line HTML
  const lineHtml = result.lines.map(l =>
    `<div class="price-summary__line"><span>${l.label}</span><span>${fmt(l.amount)}</span></div>`
  ).join('');

  // Top breakdown panel
  if (summaryLinesEl) summaryLinesEl.innerHTML = lineHtml;
  if (summaryTotalEl) summaryTotalEl.textContent = fmt(result.total);
  if (summaryEl) {
    summaryEl.setAttribute('aria-hidden', 'false');
    summaryEl.classList.add('price-summary--visible');
  }

  // Inline summary near submit
  if (inquirySummaryLinesEl) inquirySummaryLinesEl.innerHTML = lineHtml;
  if (inquirySummaryTotalEl) inquirySummaryTotalEl.textContent = fmt(result.total);
  if (inquirySummaryEl) inquirySummaryEl.classList.add('inquiry-price-summary--visible');
}

// ── Toggle group binding ──────────────────────────────────────────────────────
function bindToggleGroup(containerId, stateKey, onChange) {
  const container = document.getElementById(containerId);
  if (!container) return;
  container.querySelectorAll('.toggle-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      container.querySelectorAll('.toggle-btn').forEach(b => b.classList.remove('toggle-btn--active'));
      btn.classList.add('toggle-btn--active');
      state[stateKey] = btn.dataset.value;
      if (onChange) onChange(btn.dataset.value);
      render();
    });
  });
}

// ── Color bubble binding ──────────────────────────────────────────────────────
function bindColorGroup(containerId, stateKey, hintId, labels) {
  const container = document.getElementById(containerId);
  if (!container) return;
  container.querySelectorAll('.color-bubble').forEach(btn => {
    btn.addEventListener('click', () => {
      container.querySelectorAll('.color-bubble').forEach(b => b.classList.remove('color-bubble--active'));
      btn.classList.add('color-bubble--active');
      state[stateKey] = btn.dataset.value;
      const hintEl = document.getElementById(hintId);
      if (hintEl && labels) hintEl.textContent = labels[btn.dataset.value] || '';
      render();
    });
  });
}

// ── Init ──────────────────────────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', () => {

  // Quantity
  const qtySelect = document.getElementById('optQuantity');
  if (qtySelect) {
    qtySelect.addEventListener('change', e => {
      state.quantity = e.target.value ? parseInt(e.target.value) : null;
      render();
    });
  }

  // Pieces
  bindToggleGroup('optPieces', 'pieces');

  // Font pairing — uses font-card elements instead of toggle-btn
  const fontGrid = document.getElementById('optFontPairing');
  if (fontGrid) {
    fontGrid.querySelectorAll('.font-card').forEach(btn => {
      btn.addEventListener('click', () => {
        fontGrid.querySelectorAll('.font-card').forEach(b => b.classList.remove('font-card--active'));
        btn.classList.add('font-card--active');
        state.fontPairing = btn.dataset.value;
        render();
      });
    });
  }

  // Font color
  bindColorGroup('optFontColor', 'fontColor', 'fontColorHint', FONT_COLOR_LABELS);

  // Envelope color
  bindColorGroup('optEnvelopeColor', 'envelopeColor', 'envelopeColorHint', ENV_COLOR_LABELS);

  // Envelope liner (YES/NO)
  bindToggleGroup('optEnvelopeLiner', 'envelopeLiner', (val) => {
    showGroup('linerTypeGroup', val === 'yes');
  });

  // Liner type — mixed: liner-card (image preview buttons) + toggle-btn (custom venue text)
  const linerGrid = document.getElementById('optLinerType');
  if (linerGrid) {
    linerGrid.querySelectorAll('.liner-card, .toggle-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        // Clear active state from all liner options
        linerGrid.querySelectorAll('.liner-card').forEach(b => b.classList.remove('liner-card--active'));
        linerGrid.querySelectorAll('.toggle-btn').forEach(b => b.classList.remove('toggle-btn--active'));
        // Set active on clicked button
        if (btn.classList.contains('liner-card')) {
          btn.classList.add('liner-card--active');
        } else {
          btn.classList.add('toggle-btn--active');
        }
        state.linerType = btn.dataset.value;
        render();
      });
    });
  }

  // Guest addressing
  bindToggleGroup('optGuestAddressing', 'guestAddressing', (val) => {
    showGroup('guestAddressingInfo', val === 'yes');
  });

  // Return addressing
  bindToggleGroup('optReturnAddressing', 'returnAddressing');

  // Rehearsal insert
  bindToggleGroup('optRehearsalInsert', 'rehearsalInsert', (val) => {
    showGroup('rehearsalQtyGroup', val === 'yes');
  });

  // Rehearsal qty
  const rqtySelect = document.getElementById('optRehearsalQty');
  if (rqtySelect) {
    rqtySelect.addEventListener('change', e => {
      state.rehearsalQty = parseInt(e.target.value);
      render();
    });
  }

  // Footer option radios — show footer text field for all options except No Footer
  document.querySelectorAll('input[name="contact[footer_option]"]').forEach(radio => {
    radio.addEventListener('change', () => {
      showGroup('qFooterTextGroup', radio.value !== 'No Footer');
    });
  });

  // Initial render
  renderFlatlay();
  render();
});
